import { WebSocketState } from '@/store/modules/websocket/websocket.types';

export const webSocketState: WebSocketState = {
    isConnected: false,
    wsReconnectedCount: 0,
    importCitationEventState: undefined,
    newImportEventState: undefined,
    fileDismissEventState: undefined,
    studyUpdateEventState: undefined,
    accountDetailErrorEventState: undefined
};